import { useCallback } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import {
  BILLING_VALID_TABS,
  type BillingTab,
  UnifiedBillingView,
  type BillingSubSearch,
  validateBillingSubSearch,
} from "@/components/billing/unified-billing-view";

interface BillingSearch extends BillingSubSearch {
  tab: BillingTab;
}

/**
 * Account-root billing — canonical `UnifiedBillingContent` mount per
 * legacy. Renders IN PLACE (no redirect), preserves URL context.
 */
export const Route = createFileRoute("/_authenticated/account/billing")({
  validateSearch: (search: Record<string, unknown>): BillingSearch => {
    const raw = typeof search.tab === "string" ? search.tab : "";
    return {
      tab: BILLING_VALID_TABS.includes(raw as BillingTab) ? (raw as BillingTab) : "subscription",
      ...validateBillingSubSearch(search),
    };
  },
  component: AccountBillingPage,
});

function AccountBillingPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate();
  const setTab = useCallback(
    (next: BillingTab) => navigate({ to: "/account/billing", search: { tab: next } }),
    [navigate],
  );
  return (
    <>
      <UnifiedBillingView activeTab={tab} onTabChange={setTab} />
      <AccountSecurityBanner />
    </>
  );
}
